import { Locale } from "../../../utils";

const i18n = Locale.getInstance();
export default [
  {
    href: "/main/lottery-qrcode",
    title: i18n.t("qrcode.agreement"),
  },
];
